import { createContext, FC, PropsWithChildren, useContext, useState } from 'react';

type TeachingBlockConflictContextType = {
  calculateConflicts: boolean;
  toggleCalculateConflicts: () => void;
};

const TeachingBlockConflictContext = createContext<TeachingBlockConflictContextType>({
  calculateConflicts: true,
} as TeachingBlockConflictContextType);

export const TeachingBlockConflictProvider: FC<PropsWithChildren> = ({ children }) => {
  const [calculateConflicts, setCalculateConflicts] = useState<boolean>(true);

  function toggleCalculateConflicts() {
    setCalculateConflicts(!calculateConflicts);
  }

  return (
    <TeachingBlockConflictContext.Provider value={{ calculateConflicts, toggleCalculateConflicts }}>
      {children}
    </TeachingBlockConflictContext.Provider>
  );
};

export const useTeachingBlockConflicts = () => useContext(TeachingBlockConflictContext);
